import { Component, OnInit } from '@angular/core';
import { AppStorage } from '../shared/services/appStorage.service';
import { Router } from '@angular/router';
import { ModalDescargaDatosEmpresaComponent } from '../shared/components/modal-descarga-datos/modal-descarga-datos-empresa.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-coordinados',
  templateUrl: './coordinados.component.html',
  styleUrls: ['./coordinados.component.css']
})
export class CoordinadosComponent implements OnInit {
  loading = true;

  constructor(
    private appStorage: AppStorage,
    private router: Router,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    if (
      this.appStorage.datosSesion.perfil !==
      this.appStorage.perfilesUsuario.EMPRESA_EDITOR
    ) {
      this.appStorage.goHome();
    } else {
      this.loading = false;
    }
  }

  showModalDescarga() {
    const dialogRef = this.dialog.open(ModalDescargaDatosEmpresaComponent, {
      width: '400px',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Descargar
        console.log('Descargar');
      }
    });

    return dialogRef;
  }
}
